"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";

export function ReviewsSection() {
  const reviews = [
    {
      stars: 5,
      title: "Le meilleur système de monitoring",
      text: "Excellente expérience, facile à utiliser. La gestion de mes instances n8n est tellement pratique - plus besoin de vérifier manuellement !",
      author: "Lucy",
      location: "London, UK",
      avatar: "👤",
    },
    {
      stars: 5,
      title: "Facile à utiliser & explorer",
      text: "Les rappels de Fresha me facilitent tellement la vie. J'ai aussi découvert quelques bons barbershops que je ne connaissais pas.",
      author: "Dan",
      location: "New York, USA",
      avatar: "👤",
    },
    {
      stars: 5,
      title: "Parfait pour surveiller mes workflows",
      text: "J'utilise Stack Flow depuis deux ans et c'est de loin la meilleure plateforme de monitoring que j'ai utilisée. Je le recommande vivement !",
      author: "Dale",
      location: "Sydney, Australia",
      avatar: "👤",
    },
    {
      stars: 5,
      title: "Mon outil incontournable",
      text: "Stack Flow est mon application de référence pour les workflows et l'automatisation. Je trouve et surveille facilement mes instances - je l'adore !",
      author: "Cameron",
      location: "Edinburgh, UK",
      avatar: "👤",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % reviews.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  return (
    <section className="relative overflow-hidden bg-black pt-16 pb-16 lg:pt-[120px] lg:pb-[120px]">
      {/* Contenu */}
      <div
        className="relative z-10 w-full mx-auto px-4 sm:px-6 lg:px-8"
        style={{
          maxWidth: "1512px",
        }}
      >
        {/* Titre */}
        <h2
          className="text-white mb-12"
          style={{
            fontFamily: "var(--font-unbounded)",
            fontSize: "clamp(28px, 3.5vw, 48px)",
            fontWeight: 700,
          }}
        >
          Reviews
        </h2>

        {/* Grille de reviews */}
        <div className="relative">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 transition-transform duration-500">
            {reviews.map((review, index) => (
              <div
                key={index}
                className="rounded-2xl backdrop-blur-xl border p-6"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.02))",
                  borderColor: "rgba(255, 255, 255, 0.1)",
                }}
              >
                {/* Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(review.stars)].map((_, i) => (
                    <span
                      key={i}
                      className="text-yellow-400"
                      style={{ fontSize: "18px" }}
                    >
                      ★
                    </span>
                  ))}
                </div>

                {/* Title */}
                <h3
                  className="text-white mb-3"
                  style={{
                    fontFamily: "var(--font-unbounded)",
                    fontSize: "16px",
                    fontWeight: 600,
                    lineHeight: "1.4",
                  }}
                >
                  {review.title}
                </h3>

                {/* Text */}
                <p
                  className="text-white/60 mb-6"
                  style={{
                    fontFamily: "Switzer, sans-serif",
                    fontSize: "14px",
                    lineHeight: "1.6",
                  }}
                >
                  {review.text}
                </p>

                {/* Author */}
                <div className="flex items-center gap-3 pt-4 border-t border-white/10">
                  <div
                    className="flex items-center justify-center rounded-full bg-white/10"
                    style={{
                      width: "40px",
                      height: "40px",
                      fontSize: "20px",
                    }}
                  >
                    {review.avatar}
                  </div>
                  <div>
                    <p
                      className="text-white"
                      style={{
                        fontFamily: "var(--font-unbounded)",
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {review.author}
                    </p>
                    <p
                      className="text-white/40"
                      style={{
                        fontFamily: "Switzer, sans-serif",
                        fontSize: "12px",
                      }}
                    >
                      {review.location}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Arrow - masqué sur mobile */}
          <div className="hidden">
            <Button
              onClick={handleNext}
              size="icon"
              className="rounded-full bg-white/10 hover:bg-white/20 w-12 h-12 cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-white"
              >
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
